import { render, staticRenderFns } from "./MediaLibrary.vue?vue&type=template&id=799fa3c4&scoped=true"
import script from "./MediaLibrary.vue?vue&type=script&lang=js"
export * from "./MediaLibrary.vue?vue&type=script&lang=js"
import style0 from "./MediaLibrary.vue?vue&type=style&index=0&id=799fa3c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799fa3c4",
  null
  
)

export default component.exports